module.exports = __webpack_public_path__ + "static/media/question.dd0d70b2.xlsx";